module.exports = __webpack_public_path__ + "static/images/technology_1_5.483d791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_1_5.png
// module id = ahWB
// module chunks = 8